import { PlusIcon } from '@heroicons/react/24/solid';
import { Table } from '@tanstack/react-table';
import { Button } from 'src/components/button';

export function FooterCell<TData>({ table }: { table: Table<TData> }) {
  const selectedRows = table.getSelectedRowModel().rows;
  const { meta } = table.options;

  const removeRows = () => {
    meta?.removeSelectedRows(
      table.getSelectedRowModel().rows.map((row) => row.index),
    );
    table.resetRowSelection();
  };

  return (
    <div className="flex items-center justify-between p-2">
      {meta?.enableRowSelection && (
        <div className="flex gap-2">
          <span className="text-sm font-normal">
            {selectedRows.length} of{' '}
            {table.getPreFilteredRowModel().rows.length} Total Rows Selected
          </span>
        </div>
      )}
      <div className="flex gap-2">
        {meta?.enableRemoveRow && selectedRows.length > 0 && (
          <Button
            data-testid="data-table-footer-cell-remove-button"
            color="red"
            onClick={removeRows}
          >
            Delete {selectedRows.length} Rows
          </Button>
        )}
        {meta?.addRow && (
          <Button
            data-testid="data-table-footer-cell-add-button"
            color="green"
            onClick={() => {
              meta?.addRow?.();
            }}
          >
            <PlusIcon className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
